import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '@/img/logo/logo_light.svg'


const _hoisted_1 = {
  key: 0,
  class: "intro"
}
const _hoisted_2 = {
  key: 0,
  class: "appMode"
}
const _hoisted_3 = { class: "appVersion" }
const _hoisted_4 = {
  key: 1,
  class: "ondeBgLogo"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "spinnerAll"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mega_spinner = _resolveComponent("mega-spinner")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_mini_spinner = _resolveComponent("mini-spinner")!
  const _component_modals_container = _resolveComponent("modals-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_mega_spinner)
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["appPageContainer", [{ withBottomCut: !_ctx.$route.meta.hideBottomCut, ondeBg: !_ctx.$route.meta.hideTopCut, topBarColored: _ctx.topBarColored }, _ctx.$route.meta.appContainerClass]]),
                  onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args))),
                  ref: "appPageContainer"
                }, [
                  (_ctx.appMode != 'production')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Modalità: " + _toDisplayString(_ctx.appMode), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_3, "v" + _toDisplayString(_ctx.appVersion), 1),
                  (!_ctx.$route.meta.hideTopCut)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
                    : _createCommentVNode("", true),
                  (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { key: _ctx.routeBuster }))
                ], 34))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }),
    (_ctx.$store.state.showSpinner > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_mini_spinner)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_modals_container)
  ], 64))
}